<div class="nav-container" [ngClass]="hideNav ? 'hide-nav': 'show-nav'" (mouseover)="showNav()">
  <div class="lang-btn">
    <a class="menu-nav__link" [ngClass]="{'active': lang==='es'}" (click)="changeLang('es')">ES</a>
    |
    <a class="menu-nav__link" [ngClass]="{'active': lang==='en'}" (click)="changeLang('en')">EN</a>
  </div>
  <div class="menu-btn" [ngClass]="{'open' : showMenu}" (click)="toggleMenu()">
    <span class="menu-btn__burger" [ngClass]="{'open' : showMenu}"></span>
  </div>
  <nav class="nav" [ngClass]="{'open' : showMenu, 'showbg':showMenuBackground}">
    <ul class="menu-nav" [ngClass]="{'open' : showMenu}" (click)="toggleMenu()">
      <li *ngFor="let menu of navMenu" class="menu-nav__item" [ngClass]="{'open' : showMenu}">
        <a href="#" class="menu-nav__link" routerLinkActive="active" [routerLink]="[menu.menu]"
          (click)="onClickScrollTo(menu.view)">{{menu.menu}}</a>
      </li>
    </ul>
  </nav>
</div>
